jQuery(document).ready(function ($) {

    $( document ).on( 'click', '.conference-room-toggle', function(){

        var toggle_id = $(this).data('id');
        $('.conference-room-flyout[data-id=' + toggle_id + ']').css('transform', 'translateX(0)');

    });

    $( document ).on( 'click', '.conference-room-close', function(){

        $(this).parent().css('transform', 'translateX(100%)');

    });

    $( document ).on( 'click', '.activity-menu-toggle', function(){

        var toggle_id = $(this).data('id');
        $('.activity-menu[data-id=' + toggle_id + ']').css('transform', 'translateX(0)');

    });

    $( document ).on( 'click', '.activity-menu-close', function(){

        $(this).parent().css('transform', 'translateX(100%)');

    });

    $('.swiper-container').each(function (index) {
        $(this).addClass('swiper-container-' + index);
        $(this).find('.swiper-pagination').addClass('swiper-pagination-' + index);
        $(this).find('.swiper-button-prev').addClass('swiper-button-prev-' + index);
        $(this).find('.swiper-button-next').addClass('swiper-button-next-' + index);
        var swiper_index = '.swiper-container-' + index;
        var pagination = '.swiper-pagination-' + index;
        var prev = '.swiper-button-prev-' + index;
        var next = '.swiper-button-next-' + index;

        new Swiper(swiper_index, {
            observer: true,
            observeParents: true,
            watchOverflow: true,
            grabCursor: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 38,
            speed: 700,
            pagination: {
                el: pagination,
                type: 'progressbar',
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                769: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
        });

    });

    $('.grid-swiper').each(function (index) {

        if (window.innerWidth <= 767) {

            $(this).addClass('swiper-container-' + index);
            $(this).append('<div class="swiper-pagination"></div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
            $(this).find('.grid-wrapper').addClass('swiper-wrapper');
            $(this).find('.grid-swiper-slide').addClass('swiper-slide');
            $(this).find('.swiper-pagination').addClass('swiper-pagination-' + index);
            $(this).find('.swiper-button-prev').addClass('swiper-button-prev-' + index);
            $(this).find('.swiper-button-next').addClass('swiper-button-next-' + index);
            var swiper_index = '.swiper-container-' + index;
            var pagination = '.swiper-pagination-' + index;
            var prev = '.swiper-button-prev-' + index;
            var next = '.swiper-button-next-' + index;

            new Swiper(swiper_index, {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                grabCursor: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 38,
                speed: 700,
                pagination: {
                    el: pagination,
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                }
            });

        }

    });

    var hero_swiper = new Swiper('.hero-slider', {
        observer: true,
        observeParents: true,
        resizeObserver: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 500,
        grabCursor: true,
        preloadImages: false,
        navigation: {
            nextEl: '.hero-slider .swiper-button-next',
            prevEl: '.hero-slider .swiper-button-prev',
        },
    });

});
